import React from 'react';
import CaseSearchResult from './CaseSearchResult';
import SiteSearchResult from "./SiteSearchResult";
import ComponentSearchResult from "./ComponentSearchResult";
import DocumentSearchResult from './DocumentSearchResult';

const ErrorResult = () => (
  <span className='text-danger'>
    Search is currently unavailable
  </span>
);

const RESULT_RENDERERS = {
  'cases': CaseSearchResult,
  'components': ComponentSearchResult,
  'documents': DocumentSearchResult,
  'error': ErrorResult,
  'sites': SiteSearchResult
};

const GenericResult = ({ result: { gid } }) => (
  <span>Unknown search result type with GID {gid}</span>
);

const SearchResult = ({ result, query }) => {
  const SpecificResult = RESULT_RENDERERS[result['_index']] || GenericResult;

  return (
    <SpecificResult
      fields={result.fields}
      highlight={result.highlight}
      query={query}
    />
  );
};

export default SearchResult;
